<template>
  <div class="resource-category-edit-form setting-form">
    <BookingExistWarningDialog
      :dialog-visible="isChildCourseConfirmDialogVisible"
      :bookings="childCourses"
      :show-notice="false"
      title="이미 개설된 수업이 있어 삭제가 불가합니다."
      message="아래는 이미 스케줄에 등록된 수업 리스트입니다. 해당하는 수업을 먼저 삭제해주시길 바랍니다."
      cancel-button-text="스케줄 페이지로 이동"
      confirm-button-text="확인"
      @confirm="closeChildCourseConfirmDialog"
      @cancel="goToSchedulePage"
    />

    <template v-if="isEditing">
      <div
        v-show="page !== 'setting'"
        class="setting-header"
      >
        <h1>수업 개설</h1>
        <h3>수업의 모든 정보를 입력해주세요.</h3>
      </div>

      <course-edit-form
        :data="editingCourse"
        :membership-system="center.policy.membership_system"
        @save="onSaveForm"
        @cancel="isEditing=false"
      />
    </template>
    <template v-else>
      <el-row :gutter="20">
        <el-col :md="8">
          <div class="setting-cell">
            <category-list
              ref="categoryList"
              category-type="course"
              :active-category-id.sync="activeCategoryId"
              @delete="handleDeleteCategory"
              @selectCategory="onSelectCategory"
            />
          </div>
        </el-col>
        <el-col :md="16">
          <template v-if="isCourseListEmpty">
            <div class="setting-cell">
              <div class="header">
                {{ categoryName }}
              </div>

              <div class="empty-message">
                <div>
                  <warning-message message="등록된 수업이 없습니다." />
                  <el-button
                    class="black"
                    @click="handleClickAddCourse"
                  >
                    수업 개설
                  </el-button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="setting-cell">
              <div class="header">
                {{ categoryName }}
              </div>
              <course-item
                v-for="course in courses"
                :key="course.id"
                :data="course"
                @modify="handleClickModifyCourse"
                @delete="handleClickDeleteCourse"
              />
            </div>
            <div class="course-controller">
              <el-button
                class="black float-md-left float-right"
                @click="handleClickAddCourse"
              >
                수업 추가
              </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import CategoryList from "../CategoryEditForm/CategoryList";
import WarningMessage from "@/components/element-ui/WarningMessage";
import CourseItem from "./CourseItem";
import CourseEditForm from "./CourseEditForm";
import _ from "lodash";
import { format, addYears } from "date-fns";
import BookingExistWarningDialog from "@/components/BookingExistWarningDialog";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "ParentCourseForm",
	components: {
		BookingExistWarningDialog,
		CourseEditForm,
		CourseItem,
		WarningMessage,
		CategoryList,
	},
	props: ["page"],
	data() {
		return {
			editingCourse: null,
			isEditing: false,
			isCourseListEmpty: false,
			courses: [],
			instructors: {},
			courseCount: 0,
			center: {},
			policy: {},
			isChildCourseConfirmDialogVisible: false,
			parentCourseBookings: [],
			activeCategoryId: null,
			categoryName: "",
			childCourses: [],
		};
	},
	computed: {
		isNextButtonDisabled() {
			return this.courseCount === 0;
		},
	},
	watch: {
		async activeCategoryId(value) {
			await this.getCoursesInCategory(value);
		},
	},
	async created() {
		await this.getInstructors();

		let { data: center } = await fiflboxApi.v1.getAccountsCenter()
		delete center.user.email;
		this.center = center;
		this.policy = center.policy;
	},
	methods: {
		format,
		handleClickModifyCourse(form) {
			this.editingCourse = form;
			this.editingCourse.categoryId = this.activeCategoryId;
			this.isEditing = true;
		},
		async syncChildCourses(parentCourseId) {
			const currentDate = new Date();
			const date_after = currentDate.toDateFormat();
			const date_before = addYears(currentDate, 1).toDateFormat();
      const { data: childCoursesByDate } = await fiflboxApi.v2.getChildCourses({
        date_after,
        date_before,
        parent_course: parentCourseId,
      })
      
			this.childCourses = _.flatten(Object.values(childCoursesByDate)).map(
				childCourse => {
					return {
						dt: childCourse.dt,
						course_name: childCourse.parent_course.name,
					};
				}
			);
		},
		async handleClickDeleteCourse(form) {
			try {
				await this.$confirm("수업을 삭제하시겠습니까?", "수업 삭제");
			} catch (err) {
				return;
			}

			let categoryId = this.activeCategoryId;
			await this.syncChildCourses(form.id);

			if (this.childCourses.length > 0) {
				return (this.isChildCourseConfirmDialogVisible = true);
			}

      await fiflboxApi.v1.deleteParentCourses(form.id);

			this.$message("수업이 삭제됐습니다.");
			await this.getCoursesInCategory(categoryId);
		},
		goToSchedulePage() {
			this.$router.push("/schedule/").catch(()=>{});
		},
		closeChildCourseConfirmDialog() {
			this.isChildCourseConfirmDialogVisible = false;
		},
		async deleteCategory(form) {
			try {
        await fiflboxApi.v1.deleteCourseCategories(form.id, form);
				await this.$refs["categoryList"].syncCategoryData();
				this.$message("카테고리가 삭제됐습니다.");
			} catch (err) {}
		},
		async handleDeleteCategory({ form, categories }) {
			if (categories.length === 1) {
				return this.$alert(
					"적어도 하나 이상 카테고리가 필요하여 삭제가 불가합니다.",
					"기본 카테고리를 삭제 중입니다.",
					{
						confirmButtonText: "확인",
						cancelButtonText: "취소",
						showClose: false,
						customClass: "fifl-message-box",
						confirmButtonClass: "gray",
						cancelButtonClass: "white",
					}
				);
			}

			if (form.parent_courses.length > 0) {
				try {
					await this.$confirm(
						"카테고리 내 수업을 먼저 삭제해주시길 바랍니다.",
						"수업을 보유한 카테고리를 삭제 중입니다.",
						{
							confirmButtonText: "확인",
							cancelButtonText: "모든 수업 삭제",
							showClose: false,
							customClass: "fifl-message-box",
							confirmButtonClass: "gray",
							cancelButtonClass: "white",
							closeOnPressEscape: false,
						}
					);

					return;
				} catch (err) {}
			}

			this.deleteCategory(form);
			let filteredCategory = categories.filter(
				category => category.id !== form.categoryId
			);
			this.activeCategoryId = filteredCategory[0].id;
		},
		handleClickAddCourse() {
			this.editingCourse = null;
			this.isEditing = true;
		},
		async onSelectCategory(categoryName) {
			this.categoryName = categoryName;
		},
		async getCoursesInCategory(categoryId) {
			this.isCourseListEmpty = false;

      let { data: courses } = await fiflboxApi.v1.getParentCourses({
        category: categoryId,
      })

			this.courses = courses.map(course => {
				let instructorNames = course.instructors
					.map(instructorId => {
						let instructor = this.instructors[instructorId];

						return instructor ? instructor.name : null;
					})
					.filter(item => item)
					.join(", ");

				return {
					...course,
					instructorNames,
				};
			});

			this.isCourseListEmpty = courses.length === 0;
			this.courseCount += courses.length;
		},
		async onSaveForm(form) {
			this.isEditing = false;
			this.courseCount += 1;
			this.activeCategoryId = form.category;

			await this.getCoursesInCategory(this.activeCategoryId);
		},
		async getInstructors() {
			let { data: instructors } = await fiflboxApi.v2.getCenterInstructors()

			instructors.forEach(instructor => {
				this.instructors[instructor.id] = instructor;
			});
		},
	},
};
</script>

<style lang="scss">
.resource-category-edit-form {
	.setting-cell {
		border-radius: 6px;
		background-color: #ffffff;
		box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
		padding: 20px;
		margin-bottom: 15px;

		.header {
			height: 27px;
			font-size: 14px;
			font-weight: 500;
			line-height: 20px;
			letter-spacing: -0.6px;
			color: #4a4a4a;
			border-bottom: solid 1px #d3d3d3;
			margin-bottom: 8px;
		}
	}

	.course-controller {
		margin: 10px 20px;
	}

	.empty-message {
		min-height: 350px;

		& > div {
			text-align: center;

			.warning-message-container {
				margin-bottom: 30px;
			}
		}
	}
}

.confirm-booking {
	border-radius: 8px;
	background-color: #f2f2f2;
	height: 177px;
	overflow: auto;
	padding: 10px;
	box-sizing: border-box;

	li {
		font-size: 14px;
		font-weight: normal;
		font-style: normal;
		font-stretch: normal;
		line-height: 20px;
		height: 20px;
		letter-spacing: -0.8px;
		color: #9b9b9b;

		span:first-child {
			display: inline-block;
			width: 143px;
			line-height: 27px;
			height: 27px;
			vertical-align: top;
			margin-right: 7px;
		}

		span:last-child {
			display: inline-block;
			width: calc(100% - 153px);
			height: 27px;
			line-height: 27px;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-wrap: normal;
			overflow: hidden;
			vertical-align: top;
		}
	}
}
</style>
